import React from "react";
import PropTypes from "prop-types";
import { Modal } from "../../../../components";

const InvoiceConflictModal = props => {
	const { lang } = global;
	const { show, onHide, isEstimate, lineItems } = props;

	const uniqueJobs = [...new Set(lineItems.map(item => item.JobEventId))];

	return (
		<Modal
			id="inv-conflict-modal"
			show={show}
			onHide={onHide}
		>
			<Modal.Header closeButton>
				<Modal.Title>
					{isEstimate ? lang.t("Estimate") : lang.t("Invoice")} {lang.t("Conflict")}
				</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<p>
					{isEstimate
						? lang.t("The following jobs are already associated with an estimate_")
						: lang.t("The following jobs are already associated with an invoice_")}
				</p>
				<div className="row">
					<div className="col-xs-3 col-md-2">
						<strong>{lang.t("Job #")}</strong>
					</div>
					<div className="col-xs-5 col-md-6">
						<strong>{lang.t("Job Name")}</strong>
					</div>
					<div className="col-xs-4">
						<strong>{isEstimate ? lang.t("Estimate") : lang.t("Invoice")} #</strong>
					</div>
				</div>
				{uniqueJobs.map(jobEventId => {
					const { JobEventTitle, NonRkPayInvoiceId, InvoiceNumber } = lineItems.find(
						({ JobEventId }) => JobEventId === jobEventId,
					);
					return (
						<div
							className="row"
							key={`jobEvent-${jobEventId}`}
						>
							<div className="col-xs-3 col-md-2">
								<a
									href={`/jobs/${jobEventId}`}
									target="_blank"
									rel="noopener noreferrer"
								>
									{jobEventId}
								</a>
							</div>
							<div className="col-xs-5 col-md-6">{JobEventTitle}</div>
							<div className="col-xs-4">
								<a
									href={`/payments/manualinvoice?id=${NonRkPayInvoiceId}`}
									target="_blank"
									rel="noopener noreferrer"
								>
									{InvoiceNumber}
								</a>
							</div>
						</div>
					);
				})}
			</Modal.Body>
			<Modal.Footer>
				<button
					type="button"
					className="btn btn-primary"
					onClick={onHide}
				>
					{lang.t("OK")}
				</button>
			</Modal.Footer>
		</Modal>
	);
};

InvoiceConflictModal.propTypes = {
	show: PropTypes.bool,
	onHide: PropTypes.func,
	isEstimate: PropTypes.bool,
	lineItems: PropTypes.array,
};

InvoiceConflictModal.defaultProps = {
	show: false,
	onHide: () => {},
	isEstimate: false,
	lineItems: [],
};

export default InvoiceConflictModal;
